import React from "react";
import { toTitleCase } from "../../../../Utils/stringUtls";
import ReviewAttribute from "../../../../Components/SharedComponent/ReviewAttribute/ReviewAttribute";
import ReviewSummarySectionHeading from "../../../../Components/SharedComponent/ReviewSummarySectionHeading/ReviewSummarySectionHeading";

const AdminWebsiteOverview = ({ data }) => {
  const { users } = data["3_0"];

  return (
    <div className="forms-instance" style={{ color: "#111" }}>
      <div i2c-grid="grid grid" className="review-summary-gap">
        <div i2c-grid="12@md">
          <ReviewSummarySectionHeading
            title="Admin Website (C-Admin)"
            className="mt-0 font-bold"
          />
        </div>

        {users
          ? users.map((user, index) => {
              const {
                iac_aw_cell,
                iac_aw_email,
                iac_aw_fax,
                iac_aw_name,
                iac_aw_phone,
                iac_aw_title,
              } = user;
              return (
                <React.Fragment key={index}>
                  <div i2c-grid="12@md">
                    <div className="review-summary-section-heading">User Details</div>
                  </div>
                  <div i2c-grid="12@md" className="review-summary-section-heading">
                    User {index + 1}
                  </div>
                  <ReviewAttribute
                    label="Name"
                    value={iac_aw_name?.length ? toTitleCase(iac_aw_name) : "-"}
                  />
                  <ReviewAttribute
                    label="Title"
                    value={
                      iac_aw_title?.length ? toTitleCase(iac_aw_title) : "-"
                    }
                  />
                  <ReviewAttribute
                    label="Phone Number"
                    value={iac_aw_phone?.length ? iac_aw_phone : "-"}
                  />
                  <ReviewAttribute
                    label="Cell Number"
                    value={iac_aw_cell?.length ? iac_aw_cell : "-"}
                  />
                  <ReviewAttribute
                    label="Email"
                    value={iac_aw_email?.length ? iac_aw_email : "-"}
                  />
                </React.Fragment>
              );
            })
          : ""}
      </div>
      <div className="divider-bottom mt-16"></div>
    </div>
  );
};
export default AdminWebsiteOverview;
